import { BaseApi } from './base.api.js';

export class ScopeDocumentApi extends BaseApi {
    constructor(client) {
        super(client, '/scope-document');
    }
}
